<template>
  <v-breadcrumbs :items="items" divider=">">
    <template v-slot:item="{ item }">
      <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
      <router-link
        v-if="item.to"
        :to="item.to"
        :class="[item.disabled && 'font-weight-bold secondary--text disabled']"
      >
        <span class="ml-1 mr-1">{{ $t(item.title) }}</span>
      </router-link>
      <span
        v-else
        class="ml-1 mr-1 section-crumb"
      >{{ $t(item.title) }}</span>
    </template>
  </v-breadcrumbs>
</template>

<script>
  export default {
    name: 'TheBreadcrumbs',
    data() {
      return {
        items: [],
      };
    },
    methods: {
      generateBreadcrumbs() {
        this.items = [];
        const section = this.findSection();
        if (section) {
          this.items.push({
            to: null,
            disabled: false,
            title: section,
            icon: null,
          });
        }
        this.$route.matched.forEach((item, index) => {
          if (index) {
            if (item.meta.title) {
              this.items.push({
                to: item.name ? { name: item.name, params: this.$route.params } : item.path,
                disabled: false,
                title: item.meta.title,
                icon: null,
              });
            }
            if (item.meta.icon) {
              this.items[0].icon = item.meta.icon;
            }
          }
        });
        if (this.items[this.items.length - 1]) {
          this.items[this.items.length - 1].disabled = true;
        }
      },
      findSection() {
        for (let i = this.$route.matched.length - 1; i >= 0; i -= 1) {
          const meta = this.$route.matched[i].meta;
          if (meta && meta.section) {
            return meta.section;
          }
        }
        return null;
      },
    },
    created() {
      this.generateBreadcrumbs();
    },
    watch: {
      $route() {
        this.generateBreadcrumbs();
      },
    },
  };
</script>

<style scoped lang="scss">
  .v-breadcrumbs {
    padding: 0;
    & > a,
    & > span.section-crumb {
      font-size: 15px;
      text-transform: uppercase;

      &.disabled {
        pointer-events: none;
      }

    }
  }
</style>
